import { render, staticRenderFns } from "./CorrespondenceSalutationUpdateForm.vue?vue&type=template&id=0c05b971"
import script from "./CorrespondenceSalutationUpdateForm.vue?vue&type=script&lang=js"
export * from "./CorrespondenceSalutationUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports